const $ = jQuery.noConflict()

var self = module.exports = {
  options: {
    incrementor: '[data-increment]'
  },

  init: function(form) {
    self.events.increment(self.options.incrementor)
    self.events.submit(form)

    $(form).each(function() {
      var calculate = $(this).data('calculator')
      var data = self.service.data(this)

      self.events.change(this)
      self.service[calculate](this, data)
    })
  },

  events: {
    submit: function(form) {
      $(document).on('submit', form, function(e) {
        var calculate = $(this).data('calculator')
        var data = self.service.data(this)
        e.preventDefault()
        self.service[calculate](this, data)
      })
    },

    change: function(form) {
      $(form).on('change', 'input, select, textarea', function(event) {
        var form = $(this).closest('form')
        $(form).trigger('submit')
      })
    },

    increment: function(trigger) {
      $(document).on('click', trigger, function(event) {
        var el = this
        var target = $(el).closest('.form-group').find('input[type="number"]')
        var increment = $(el).data('increment')
        var form = $(el).closest('form')

        self.service.increment(target, increment)
        $(form).trigger('submit')
      })
    }
  },

  service: {
    beautify: function(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    result: function(form, result) {
      var target = $(form).find('[data-result]')

      target.text(self.service.beautify(result))
    },

    results: function(form, results) {
      var targets = $(form).find('[data-result]')
      var i = 0

      $(targets).each(function() {
        if( typeof results === 'string' ) {
          $(this).text(self.service.beautify(results))
        } else {
          $(this).text(self.service.beautify(results[i]))
          i++
        }
      })
    },

    increment: function(target, increment) {
      var input = $(target).val()
      var decimals = $(target).data('decimals')
      var min = $(target).attr('min') ? $(target).attr('min') : false
      var max = $(target).attr('max') ? $(target).attr('max') : false
      var output = null
      var valid = true
      input = parseFloat(input)
      increment = parseFloat(increment)
      output = parseFloat(input + increment)

      if (decimals > 0) {
        output = parseFloat(output.toFixed(decimals))
      }

      if (min !== false && output < min) {
        valid = false
      }

      if (max !== false && output > max) {
        valid = false
      }

      if (valid === true) {
        $(target).val(output)
      }
    },

    data: function(form) {
      var formArray = $(form).serializeArray()
      var data = {}

      for (var i = 0; i < formArray.length; i++){
        data[formArray[i]['name']] = isNaN(parseFloat(formArray[i]['value'])) ? formArray[i]['value'] : parseFloat(formArray[i]['value'])
      }

      return data
    },

    mortgage: function(form, data) {
      data.loan = data.price-data.deposit
      data.rateCalc = (data.rate/100)/12
      data.lengthCalc = data.length * 12
      data.exponent = Math.pow((1+(data.rateCalc)), (-(data.lengthCalc)))
      var monthly = Math.round((data.loan*data.rateCalc)/(1 - data.exponent))

      self.service.result(form, monthly)
    },

    yield: function(form, data) {
      var value = 0
      value = ((((data.rent * 12) / data.value) * 100) + 0.00001).toFixed(2)

      self.service.result(form, value)
    },

    helptobuy: function(form, data) {
      var results = []
      var loan = data.price * .2
      var mortgage = data.price - (data.deposit + loan)

      results.push(loan, mortgage)

      self.service.results(form, results)
    },

    stamp: function (form, data) {
      var currentDate = new Date();
      var holidayStart = new Date("2020-07-08");
      // var holidayEnd = new Date('2021-07-01')
      var holidayEnd = new Date("2021-10-01"); // Bug in enddate
      var holidayActive = false;
      var reducedRateStartDate = holidayEnd;
      var reducedRateEndDate = new Date("2021-10-01");
      var reducedRateActive = false;

      var bands = [0, 250000, 925000, 1500000];
      var rates = [0, 0.05, 0.1, 0.12];
      var amounts = [];
      var stampDuty = 0;

      if (currentDate >= holidayStart && currentDate < holidayEnd) {
        holidayActive = true;
        bands = [0, 250000, 925000, 1500000]; // old value < 4 aug : [0, 500000, 925000, 1500000];
        rates = [0, 0.05, 0.1, 0.12];
      }

      // Adjust bands and rates for reduced rate of stamp duty after holiday ends.
      if (
        currentDate >= reducedRateStartDate &&
        currentDate < reducedRateEndDate
      ) {
        reducedRateActive = true;
        bands = [0, 250000, 925000, 1500000];
        rates = [0, 0.05, 0.1, 0.12];
      }

      if (data.type === "first" && data.price <= 625000) {
        if (holidayActive) {
          // Adjust bands and rates for stamp duty holiday
          bands = [0];
          rates = [0];
        } else {
          // Adjust bands and rates for threshold
          bands = [0, 425000]; //300000
          rates = [0, 0.05];
        }
      } else if (data.type === "additional") {
        if (holidayActive || reducedRateActive) {
          // Adjust rates for stamp duty holiday
          rates = [0.03, 0.08, 0.13, 0.15];
        } else {
          // Modified stamp duty on additional owned properties
          var modifier = 0.03;
          rates = rates.map(function (val) {
            val = val + modifier;
            return val;
          });
        }
        if (data.price < 40000) {
          // No stamp duty on additional properties under 40,000
          rates[0] = 0;
        }
      }
      /*
       * Stampy duty calculation (Part 1)
       */
      for (let i = 0; i < bands.length; i++) {
        if (data.price > bands[i]) {
          if (i === bands.length - 1 || data.price - bands[i + 1] < 0) {
            amounts[i] = data.price - bands[i];
          } else {
            amounts[i] = bands[i + 1] - bands[i];
          }
        }
      }
      /*
       * Stampy duty calculation (Part 2)
       *
       * For each value in the amounts array, apply the appropraite rate
       * to the amount and add it to the stamp duty total.
       */
      for (let i = 0; i < amounts.length; i++) {
        stampDuty = stampDuty + amounts[i] * rates[i];
      }
      stampDuty = parseFloat(stampDuty).toFixed(2);
      self.service.results(form, self.service.beautify(stampDuty));
    },
  }
}
